module.exports = __webpack_public_path__ + "img/bg2.110420cf.png";